// Core
import React, { lazy, useEffect, useState } from 'react';
import {
  Card, Row, Col, Table, Spin, Tooltip, Modal, notification, Form, Input, Button, Badge, Calendar
} from 'antd';

import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Moment from 'moment';
import 'moment/locale/es-mx';


// App
import {
  pacienteHistorialListAction, pacienteHistorialCreateAction, pacienteReadAction
} from '../../../redux/clinica/pacientes/actionCreator';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';

const getListData = (value) => {
  let listData;

  switch (value.date()) {
    case 8:
      listData = [
        {
          type: 'warning',
          content: 'Juan Carlos Garcia',
        },
        {
          type: 'success',
          content: 'María Hernández',
        },
      ];
      break;

    case 10:
      listData = [
        {
          type: 'warning',
          content: 'Dante Ramírez',
        },
        {
          type: 'success',
          content: 'Delia López',
        },
        {
          type: 'error',
          content: 'Joaquín Andrade',
        },
      ];
      break;

    case 15:
      listData = [
        {
          type: 'warning',
          content: 'Paciente',
        },
        {
          type: 'success',
          content: 'Paciente',
        },
        {
          type: 'error',
          content: 'Paciente 1.',
        },
        {
          type: 'error',
          content: 'Paciente 2.',
        },
        {
          type: 'error',
          content: 'Paciente 3.',
        },
        {
          type: 'error',
          content: 'Paciente 4.',
        },
      ];
      break;

    default:
  }

  return listData || [];
};

const getMonthData = (value) => {
  if (value.month() === 8) {
    return 1394;
  }
};

const AgendaView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.PacienteReducer.data);
  const registro = useSelector(state => state.PacienteReducer.record);
  const { id } = useParams();
  const [form] = Form.useForm();

  const [nombre, setNombre] = useState('Cargando...');
  const [modalVisible, setModalVisible] = useState(false);

  const monthCellRender = (value) => {
    const num = getMonthData(value);
    return num ? (
      <div className="notes-month">
        <section>{num}</section>
        <span>Backlog number</span>
      </div>
    ) : null;
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    return (
      <ul className="events">
        {listData.map((item) => (
          <li key={item.content}>
            <Badge status={item.type} text={item.content} />
          </li>
        ))}
      </ul>
    );
  };




  return (
    <>
      <Card>
        <Calendar dateCellRender={dateCellRender} monthCellRender={monthCellRender} />;

      </Card>

    </>
  );
};

export default AgendaView;
